import ListPage from './ListPage';
import CreatePage from './CreatePage';
import DetailsPage from './DetailsPage';
import VerifyBounceDomainPage from './VerifyBounceDomainPage';
import VerifySendingDomainPage from './VerifySendingDomainPage';
import VerifySendingBounceDomainPage from './VerifySendingBounceDomainPage';
import VerifyTrackingDomainPage from './VerifyTrackingDomainPage';

export default {
  ListPage,
  CreatePage,
  DetailsPage,
  VerifyBounceDomainPage,
  VerifySendingDomainPage,
  VerifySendingBounceDomainPage,
  VerifyTrackingDomainPage
};
